import api from "./api";

/**
 * @description Servicio para /images.
 * Gestiona el catálogo de órdenes de imagen.
 */
const imageCatalogService = {};

/**
 * @description Obtiene listado de imágenes con filtros
 * @param {Object} params
 * @returns {Promise<Array>}
 */
imageCatalogService.getAll = function (params) {
  return api.get("/images", { params }).then((res) => res.data);
};

/**
 * @description Obtiene las categorías disponibles
 * @returns {Promise<Array<string>>}
 */
imageCatalogService.getCategories = function () {
  return api.get("/images/categories").then((res) => res.data);
};

/**
 * @description Crea una imagen
 * @param {Object} data
 * @returns {Promise<Object>}
 */
imageCatalogService.create = function (data) {
  return api.post("/images", data).then((res) => res.data);
};

/**
 * @description Actualiza una imagen
 * @param {string} id
 * @param {Object} data
 * @returns {Promise<Object>}
 */
imageCatalogService.update = function (id, data) {
  return api.put(`/images/${id}`, data).then((res) => res.data);
};

/**
 * @description Elimina una imagen (soft delete)
 * @param {string} id
 * @returns {Promise<void>}
 */
imageCatalogService.delete = function (id) {
  return api.delete(`/images/${id}`);
};

export default imageCatalogService;
